'use client';

import { useState } from 'react';

import type { Reference } from '@eliadmin/core/src/api/references/references-types';

import { LightboxComponent } from '@eliadmin/core/src/components/lightbox/lightbox-component';
import { UniversalCard } from '@eliadmin/core/src/components/shared/universal-card';
import { useDisclosure } from '@eliadmin/core/src/hooks/use-disclosure';

import { cn } from '@eliadmin/core/src/utils/style-utils';

export const ReferencesList = ({ references }: { references: Reference[] }) => {
  const { isOpen, setIsOpen } = useDisclosure(false);
  const [imagesSorted, setImagesSorted] = useState([]);

  const handleOpenGallery = (data: any) => () => {
    if (Array.isArray(data.images) && data.images.length > 0) {
      setImagesSorted(data.images);
      setIsOpen(true);
    }
  };

  return (
    <>
      <LightboxComponent isOpen={isOpen} setIsOpen={setIsOpen} images={imagesSorted} />
      <section className={cn('', 'ea-references-list__section')}>
        <h2>Referencie</h2>
        <div className={cn('', 'ea-references-list__container')}>
          {references.map((item, index) => {
            const data = {
              slug: item?.slug,
              image: item.image,
              name: item.name,
              images: item.images,
            };

            return (
              <div
                key={data.slug}
                className={cn('', 'ea-references-list__card-wrapper')}
                onClick={handleOpenGallery(data)}
              >
                <UniversalCard index={index} data={data} />
              </div>
            );
          })}
        </div>
      </section>
    </>
  );
};
